export default "__VITE_ASSET__0_eP_KML__"